import { BASE_URL } from "../constants";
import { getAuthToken } from "../utils";

export async function fetchConvenioList() {
  const token = getAuthToken();
  const res = await fetch(`${BASE_URL}insurance/medical-center-convenios/`, {
    headers: {
      Authorization: token ? `Token ${token}` : undefined,
    },
  });
  if (!res.ok) throw new Error("Error al obtener convenios");
  return res.json();
}

export async function saveConvenio(convenioData) {
  const token = getAuthToken();
  const res = await fetch(`${BASE_URL}insurance/medical-center-convenios/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? `Token ${token}` : undefined,
    },
    body: JSON.stringify(convenioData),
  });
  if (!res.ok) throw new Error("Error al guardar convenio");
  return res.json();
}
